// this needs to be moved to ENV
export const CURRENCY_SYMBOL = '₹';
